module.exports = __webpack_public_path__ + "static/img/szsc.c08d9bd3.png";